const elements = document.querySelectorAll('.rlt-display-text');

if (elements.length > 0) {
	const textObserver = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add('rlt-display-text-visible');
				textObserver.unobserve(entry.target);
			}
		});
	});

	elements.forEach((element) => {
		textObserver.observe(element);
	});
}
